/* =====================================================================
   Wise — pied de page « whft » (snippets/footer.liquid), toutes les pages.
   Autonome (ne dépend pas de wh-core.js), ES2017, idempotent.
   - accordéons des menus sur mobile (< 750 px) ;
   - newsletter : validation claire, état d’envoi, message après envoi,
     masquée si l’inscription du club Wise est déjà sur la page ;
   - copie de l’e-mail du support ;
   - bouton « Gérer les cookies » si la bannière Shopify est active ;
   - lien « Haut de page » (mobile) : défilement doux + focus sur le contenu.
   N’écoute aucun crochet de wise.js (#back-top, data-copy-text… restent à lui).
   ===================================================================== */
(function () {
  'use strict';

  var SENT_KEY = 'whft-news-sent';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function announce(text) {
    var live = document.getElementById('live-region');
    if (!live || !text) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }

  /* ---------- Accordéons ---------- */
  function setOpen(col, btn, open) {
    col.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initCols(root) {
    var cols = root.querySelectorAll('[data-whft-col]');
    Array.prototype.forEach.call(cols, function (col) {
      var btn = col.querySelector('[data-whft-col-btn]');
      if (!btn) return;
      setOpen(col, btn, false);
      btn.addEventListener('click', function () {
        setOpen(col, btn, btn.getAttribute('aria-expanded') !== 'true');
      });
    });

    /* Le lien de la page en cours ouvre sa colonne */
    var current = root.querySelector('.whft-col [aria-current="page"]');
    if (current) {
      var col = current.closest('[data-whft-col]');
      var btn = col && col.querySelector('[data-whft-col-btn]');
      if (col && btn) setOpen(col, btn, true);
    }
  }

  /* ---------- Newsletter ---------- */
  function clubOnPage() {
    return !!document.querySelector('.wh-club__form');
  }

  function initNews(root) {
    var news = root.querySelector('[data-whft-news]');
    var service = root.querySelector('[data-whft-service]');
    if (!news) {
      if (service) service.classList.add('whft-service--solo');
      return;
    }

    if (clubOnPage()) {
      news.hidden = true;
      if (service) service.classList.add('whft-service--solo');
      return;
    }

    /* Shopify marque comme envoyés tous les formulaires « customer » de la page.
       Envoi depuis CE formulaire (repère de session posé à l’envoi, ou ancre
       #whft-newsletter) : on garde le message et on l’amène à l’écran.
       Envoi d’un autre formulaire client (ex. « Prévenez-moi du retour ») :
       on retire le message et on réaffiche les champs (rendus masqués). */
    var done = news.querySelector('[data-whft-done]');
    if (done) {
      var mine = false;
      try { mine = sessionStorage.getItem(SENT_KEY) === '1'; sessionStorage.removeItem(SENT_KEY); } catch (e) { mine = false; }
      var fields = news.querySelector('[data-whft-fields]');
      if (mine || window.location.hash === '#whft-newsletter') {
        try { done.focus({ preventScroll: true }); } catch (e) { /* ancien navigateur */ }
        done.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
        return;
      }
      if (!fields) return;
      if (done.parentNode) done.parentNode.removeChild(done);
      fields.hidden = false;
    }
    /* Formulaire affiché (envoi refusé ou nouvelle page) : repère périmé */
    try { sessionStorage.removeItem(SENT_KEY); } catch (e) { /* stockage indisponible */ }

    var form = news.querySelector('form');
    var input = news.querySelector('.whft-news__input');
    var check = news.querySelector('.whft-news__check');
    var err = news.querySelector('[data-whft-err]');
    var field = news.querySelector('.whft-news__field');
    var btn = news.querySelector('.whft-news__btn');
    var label = news.querySelector('[data-whft-label]');
    if (!form || !input || !err) return;

    var msg = {
      empty: news.getAttribute('data-msg-empty') || '',
      invalid: news.getAttribute('data-msg-invalid') || '',
      consent: news.getAttribute('data-msg-consent') || '',
      sending: news.getAttribute('data-msg-sending') || ''
    };

    form.setAttribute('novalidate', '');

    function showError(text, target) {
      err.textContent = text;
      err.hidden = false;
      if (target === input) {
        input.setAttribute('aria-invalid', 'true');
        if (field) field.classList.add('is-invalid');
      } else if (target === check) {
        check.setAttribute('aria-invalid', 'true');
      }
      if (target) target.focus();
    }

    function clearError() {
      err.hidden = true;
      err.textContent = '';
      input.removeAttribute('aria-invalid');
      if (field) field.classList.remove('is-invalid');
      if (check) check.removeAttribute('aria-invalid');
    }

    input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid') === 'true') clearError();
    });
    if (check) {
      check.addEventListener('change', function () {
        if (check.checked && check.getAttribute('aria-invalid') === 'true') clearError();
      });
    }

    form.addEventListener('submit', function (e) {
      if (form.__whftSending) { e.preventDefault(); return; }
      var value = (input.value || '').trim();
      input.value = value;
      if (!value) { e.preventDefault(); showError(msg.empty, input); return; }
      if (!EMAIL_RE.test(value)) { e.preventDefault(); showError(msg.invalid, input); return; }
      if (check && !check.checked) { e.preventDefault(); showError(msg.consent, check); return; }
      clearError();
      form.__whftSending = true;
      try { sessionStorage.setItem(SENT_KEY, '1'); } catch (err2) { /* stockage indisponible */ }
      if (btn) btn.setAttribute('aria-busy', 'true');
      if (label && msg.sending) label.textContent = msg.sending;
    });

    /* Retour arrière depuis la page suivante (cache du navigateur) */
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      form.__whftSending = false;
      if (btn) btn.removeAttribute('aria-busy');
      if (label && label.__whftText) label.textContent = label.__whftText;
    });
    if (label) label.__whftText = label.textContent;
  }

  /* ---------- Copie de l’e-mail ---------- */
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  function initCopy(root) {
    var btn = root.querySelector('[data-whft-copy]');
    if (!btn) return;
    var canCopy = !!(navigator.clipboard && navigator.clipboard.writeText) ||
      !!(document.queryCommandSupported && document.queryCommandSupported('copy'));
    if (!canCopy) return;
    btn.hidden = false;

    var labelEl = btn.querySelector('[data-whft-copy-label]');
    var base = labelEl ? labelEl.textContent : '';
    var timer = 0;

    function success() {
      btn.classList.add('is-copied');
      if (labelEl) labelEl.textContent = btn.getAttribute('data-whft-copied') || base;
      announce(btn.getAttribute('data-whft-copied-sr'));
      clearTimeout(timer);
      timer = setTimeout(function () {
        btn.classList.remove('is-copied');
        if (labelEl) labelEl.textContent = base;
      }, 2000);
    }

    btn.addEventListener('click', function () {
      var text = btn.getAttribute('data-whft-copy') || '';
      if (!text) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(success, function () {
          if (legacyCopy(text)) success();
        });
      } else if (legacyCopy(text)) {
        success();
      }
    });
  }

  /* ---------- Préférences cookies (bannière Shopify) ---------- */
  function initCookies(root) {
    var btn = root.querySelector('[data-whft-cookies]');
    if (!btn) return;
    var tries = 0;

    function available() {
      return !!(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function');
    }

    function check() {
      if (available()) { btn.hidden = false; return; }
      tries += 1;
      if (tries < 4) setTimeout(check, 1500);
    }

    btn.addEventListener('click', function () {
      if (available()) window.privacyBanner.showPreferences();
    });

    if (document.readyState === 'complete') check();
    else window.addEventListener('load', check, { once: true });
  }

  /* ---------- Haut de page (mobile ; #back-top du thème au-delà) ---------- */
  function initTop(root) {
    var link = root.querySelector('[data-whft-top]');
    if (!link) return;
    link.addEventListener('click', function (e) {
      var target = document.getElementById('MainContent');
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' });
      if (target) {
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        try { target.focus({ preventScroll: true }); } catch (err) { /* ancien navigateur */ }
      }
    });
  }

  /* ---------- Initialisation ---------- */
  function init(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    var roots = ctx.querySelectorAll('[data-whft]');
    if (!roots.length && ctx.matches && ctx.matches('[data-whft]')) roots = [ctx];
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__whftInit) return;
      root.__whftInit = true;
      root.classList.add('whft--js');
      try { initCols(root); } catch (e) { if (window.console) console.error('[whft]', e); }
      try { initNews(root); } catch (e) { if (window.console) console.error('[whft]', e); }
      try { initCopy(root); } catch (e) { if (window.console) console.error('[whft]', e); }
      try { initCookies(root); } catch (e) { if (window.console) console.error('[whft]', e); }
      try { initTop(root); } catch (e) { if (window.console) console.error('[whft]', e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Éditeur de thème : le pied de page est un snippet, mais une section
     ajoutée, rechargée ou retirée (club Wise) change l’affichage de la newsletter. */
  function syncClub() {
    var root = document.querySelector('[data-whft]');
    var news = root && root.querySelector('[data-whft-news]');
    if (!news) return;
    var club = clubOnPage();
    news.hidden = club;
    var service = root.querySelector('[data-whft-service]');
    if (service) service.classList.toggle('whft-service--solo', club);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    syncClub();
  });
  document.addEventListener('shopify:section:unload', function () {
    setTimeout(syncClub, 0);
  });
})();
